import React from 'react';
import { Tooltip } from 'antd';
import './StackedProgressBar.scss';

export interface ProgressSegment {
    label: string;
    value: number;
    color: string;
}

interface StackedProgressBarProps {
    label?: string;
    segments: ProgressSegment[];
    size?: 'sm' | 'lg';
    showLegend?: boolean;
    tooltipContent?: React.ReactNode;
}

const StackedProgressBar: React.FC<StackedProgressBarProps> = ({
    label,
    segments,
    size = 'sm',
    showLegend = false,
    tooltipContent: customTooltip,
}) => {
    const total = segments.reduce((sum, s) => sum + s.value, 0);

    const defaultTooltip = (
        <div className="stacked-bar-tooltip">
            {segments.map((s, i) => (
                <div key={i} className="stacked-bar-tooltip__row">
                    <span
                        className="stacked-bar-tooltip__swatch"
                        style={{ backgroundColor: s.color }}
                    />
                    <span>
                        {s.label}: {s.value}%
                    </span>
                </div>
            ))}
        </div>
    );

    const tooltipContent = customTooltip ?? defaultTooltip;

    return (
        <div
            className={`stacked-progress ${showLegend ? 'stacked-progress--vertical' : ''}`}
        >
            {label && <span className="stacked-progress__label">{label}</span>}
            <div className="stacked-progress__bar-wrapper">
                <Tooltip title={tooltipContent}>
                    <div
                        className={`stacked-progress__bar stacked-progress__bar--${size}`}
                    >
                        {segments.map((s, i) => (
                            <div
                                key={i}
                                className="stacked-progress__segment"
                                style={{
                                    width: s.value + '%',
                                    backgroundColor: s.color,
                                }}
                            />
                        ))}
                    </div>
                </Tooltip>
            </div>
            {!showLegend && segments.length === 1 && (
                <span className="stacked-progress__pct">{total}%</span>
            )}
            {showLegend && (
                <div className="stacked-progress__legend">
                    {segments.map((s, i) => (
                        <div key={i} className="stacked-progress__legend-item">
                            <span
                                className="stacked-progress__legend-swatch"
                                style={{ backgroundColor: s.color }}
                            />
                            <span className="stacked-progress__legend-label">
                                {s.label}: {s.value}%
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default StackedProgressBar;
